module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-11.8d62ee55.png";